import Decimal from "decimal.js";

export const ACATS_OUT_FEES = new Decimal(75);
